// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"654598d7","453":"fb0b5771","732":"3f5f4abc","977":"c2ee01fa"}[chunkId] + ".chunk.js";
};